import React from "react";
import { Box, Typography, Button } from "@bca/ui-library";

import { formatMoney } from "./formatMoney";

interface BuyNowContentProps {
  layout: "BidNowBuyNow" | "BuyNow";
  buyNowAmount: number;
  onBuy: () => void;
}

const BuyNowContent: React.FunctionComponent<BuyNowContentProps> = ({
  layout,
  buyNowAmount,
  onBuy,
}) => {
  const useBuyNowCardLayout = layout === "BuyNow";

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection={useBuyNowCardLayout ? "row" : ["row", "row", "column"]}
      alignItems={
        useBuyNowCardLayout ? "center" : ["center", "center", "flex-start"]
      }
      justifyContent="space-between"
    >
      <Box display="flex" flexDirection="column">
        <Typography variant="h6" mt={0} mb={1}>
          Buy Now
        </Typography>
        <Box
          display="flex"
          alignItems={
            useBuyNowCardLayout ? ["flex-start", "flex-end"] : ["flex-start"]
          }
          flexDirection={useBuyNowCardLayout ? ["column", "row"] : ["column"]}
        >
          <Typography
            variant="h6"
            mt={0}
            mb={1}
            mr={3}
            css={`
              font-size: 30px;
            `}
          >
            {formatMoney(buyNowAmount)}
          </Typography>
          <Typography variant="body" color="grey-blue" mt={0} mb={[0, 0, 3]}>
            Excl. Fees
          </Typography>
        </Box>
      </Box>
      <Button
        variant="primary-gradient"
        m={0}
        onClick={onBuy}
        data-en="click"
        data-ec="button"
        data-el="buynow"
        data-ea="open"
        data-es=""
      >
        Buy Now
      </Button>
    </Box>
  );
};

export default BuyNowContent;
